import { request } from '@/utils/requestHelpers';

export interface ReferralParams {
  email: string;
}

export async function sendReferral({ email }: ReferralParams) {
  const formData = new FormData();
  formData.append('email', email);

  const response = await request('/api/v5/invites', {
    method: 'POST',
    body: formData,
  });

  return {
    invite: response.invite,
    meta: response.meta,
  };
}
